import { Role } from '@/enums';

export const DEFAULT_ROLES = [
  Role.ADMIN,
  Role.OPERATIONS,
  Role.SUPER_ADMIN,
  Role.LAB_STAFF_USER,
];

export enum ModuleUsingLimitContent {
  PRODUCT = 'product',
}

export enum LimitContentAction {
  ALLOW = 'allow',
  DENIED = 'denied',
}
export enum BulkActionLimitContentEnum {
  DENIED_ALL = 'DENIED_ALL',
  ALLOW_ALL = 'ALLOW_ALL',
}
